import { string, object } from 'yup';

import { message } from 'shared/helpers/constants/notes/createNoteConstants';

export const ProcessingNoteSchema = object().shape({
  note: string().max(255, message.INVALID_NOTE_LENGTH()).required(message.INVALID_NOTE),
});
